export default {
  'Your win': 'Câștigul tău',
  'Select skins that you want to take': 'Selectează fațetele pe care vrei să le iei',
  'By price': 'După preț',
  '(Autotrade will receive after 10 minutes)': '(Autotrade va primi după 10 minute)',
  ACCEPT: 'Confirmare',
  'SELECT ALL': 'SELECT ALL',
};
